export const setBudget = (budget) => ({
  type: "SET_BUDGET",
  payload: budget,
});

export default setBudget;
